module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1BfYv"))).then(() => parcelRequire('ljYL6'));